// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/search/place_result.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_entity_place } from "../entity/place_pb";

/**
 * Describes the file proto/model/search/place_result.proto.
 */
export const file_proto_model_search_place_result = /*@__PURE__*/
  fileDesc("CiVwcm90by9tb2RlbC9zZWFyY2gvcGxhY2VfcmVzdWx0LnByb3RvEgZjYXJtZW4iKwoLUGxhY2VSZXN1bHQSHAoFcGxhY2UYASABKAsyDS5jYXJtZW4uUGxhY2VCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_proto_model_entity_place]);

/**
 * Describes the message carmen.PlaceResult.
 * Use `create(PlaceResultSchema)` to create a new message.
 */
export const PlaceResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_place_result, 0);

